/*
 * =============================================================================
 * Project: payments.telestrada-online.pl
 * Created Date: 2018-07-11, 17:05:04
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-07-17, 12:11:26
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */

import Vue from 'vue';
import VueMq from 'vue-mq';
import Raven from 'raven-js';
import RavenVue from 'raven-js/plugins/vue';
import '@sh/vue-component-ui';
import '@sh/vue-component-ui/dist/sh.css';

import 'font-awesome/css/font-awesome.css';
import './assets/styles/style.sass';

import { ShI18n, i18n } from './translate';
import store from './store';
import App from './App';
import router from './router';

Vue.config.productionTip = false;

/* eslint-disable no-new */
Vue.use(ShI18n);

Vue.use(VueMq, {
  breakpoints: {
    sm: 450,
    md: 1250,
    lg: Infinity,
  },
});

new Vue({
  el: '#app',
  i18n,
  store,
  router,
  template: '<App/>',
  components: { App },
});

if (process.env.SENTRY) {
  Raven
    .config('https://0f00d6f747714783835d46385c74688b@sentry.io/1257629')
    .addPlugin(RavenVue, Vue)
    .install();
}




// WEBPACK FOOTER //
// ./src/main.js